"use client"

import { useState } from "react"
import { CheckCircle2 } from "lucide-react"

export function ContactForm() {
  const [submitted, setSubmitted] = useState(false)

  if (submitted) {
    return (
      <div className="flex h-full min-h-80 flex-col items-center justify-center rounded-3xl border border-border bg-card p-10 text-center">
        <CheckCircle2 className="size-12 text-brand" aria-hidden="true" />
        <h2 className="mt-4 font-sans text-2xl font-semibold text-foreground">Thanks — we&apos;ll be in touch</h2>
        <p className="mt-2 max-w-sm text-muted-foreground">
          A member of the Rombex team will reach out to the email you provided shortly.
        </p>
      </div>
    )
  }

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault()
        setSubmitted(true)
      }}
      className="rounded-3xl border border-border bg-card p-6 shadow-sm md:p-8"
    >
      <div className="grid gap-5">
        <div className="grid gap-2">
          <label htmlFor="name" className="text-sm font-medium text-foreground">
            Full name
          </label>
          <input
            id="name"
            name="name"
            required
            className="h-11 rounded-xl border border-border bg-background px-4 text-foreground outline-none transition-colors focus:border-brand focus:ring-2 focus:ring-brand/30"
            placeholder="Jane Doe"
          />
        </div>
        <div className="grid gap-2">
          <label htmlFor="email" className="text-sm font-medium text-foreground">
            Work email
          </label>
          <input
            id="email"
            name="email"
            type="email"
            required
            className="h-11 rounded-xl border border-border bg-background px-4 text-foreground outline-none transition-colors focus:border-brand focus:ring-2 focus:ring-brand/30"
            placeholder="jane@company.com"
          />
        </div>
        <div className="grid gap-2">
          <label htmlFor="company" className="text-sm font-medium text-foreground">
            Company
          </label>
          <input
            id="company"
            name="company"
            className="h-11 rounded-xl border border-border bg-background px-4 text-foreground outline-none transition-colors focus:border-brand focus:ring-2 focus:ring-brand/30"
            placeholder="Company Inc."
          />
        </div>
        <div className="grid gap-2">
          <label htmlFor="message" className="text-sm font-medium text-foreground">
            How can we help?
          </label>
          <textarea
            id="message"
            name="message"
            rows={4}
            className="rounded-xl border border-border bg-background px-4 py-3 text-foreground outline-none transition-colors focus:border-brand focus:ring-2 focus:ring-brand/30"
            placeholder="Tell us about your use case..."
          />
        </div>
        <button
          type="submit"
          className="mt-1 inline-flex h-12 items-center justify-center rounded-full bg-brand px-6 font-medium text-brand-foreground shadow-sm transition-all hover:bg-brand/90 hover:shadow-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2"
        >
          Request a demo
        </button>
      </div>
    </form>
  )
}
